var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73004 4.76587L6.41144 8.38913C6.49176 8.46859 6.60019 8.51316 6.71318 8.51316C6.82617 8.51316 6.9346 8.46859 7.01492 8.38913L10.6963 4.76666C10.7771 4.68723 10.8859 4.64273 10.9992 4.64273C11.1126 4.64273 11.2213 4.68723 11.3022 4.76666C11.342 4.80546 11.3736 4.85183 11.3952 4.90304C11.4168 4.95426 11.4279 5.00928 11.4279 5.06486C11.4279 5.12044 11.4168 5.17546 11.3952 5.22668C11.3736 5.27789 11.342 5.32427 11.3022 5.36307L7.62155 8.98554C7.37912 9.22357 7.05294 9.35693 6.71318 9.35693C6.37343 9.35693 6.04725 9.22357 5.80481 8.98554L2.1242 5.36307C2.08428 5.32425 2.05255 5.27783 2.03088 5.22655C2.00921 5.17526 1.99805 5.12015 1.99805 5.06447C1.99805 5.00879 2.00921 4.95368 2.03088 4.90239C2.05255 4.85111 2.08428 4.80468 2.1242 4.76587C2.20502 4.68645 2.3138 4.64194 2.42712 4.64194C2.54043 4.64194 2.64922 4.68645 2.73004 4.76587Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownColumn);
export default __webpack_public_path__ + "static/media/arrowDownColumn.1aae9d99ce3c502557f4ee7819668902.svg";
export { ForwardRef as ReactComponent };